// import React, { useState, useRef, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { Box, Typography, TextField, Button, Paper, CircularProgress, IconButton, InputAdornment } from '@mui/material';
// import BarChartIcon from "@mui/icons-material/BarChart";
// import TrendingUpIcon from "@mui/icons-material/TrendingUp";
// import PeopleIcon from "@mui/icons-material/People";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import { Visibility, VisibilityOff } from "@mui/icons-material";

// export default function Registration({ connectionString }) {
//     const navigate = useNavigate();
//     const path = connectionString;

//     // ================= EXISTING LOGIC (UNCHANGED) =================
//     const [userName, setUserName] = useState('');
//     const [mobileNumber, setMobileNumber] = useState('');
//     const [employeeName, setEmployeeName] = useState('');
//     const [userEmailId, setUserEmailId] = useState('');
//     const [userPassword, setUserPassword] = useState('');
//     const [otp, setOtp] = useState(['', '', '', '', '', '']);
//     const [otpSent, setOtpSent] = useState(false);
//     const [otpFocused, setOtpFocused] = useState(false);
//     const [otpLoading, setOtpLoading] = useState(false);

//     const [usernameError, setUsernameError] = useState('');
//     const [usernameValid, setUsernameValid] = useState(false);
//     const [mobileError, setMobileError] = useState('');
//     const [mobileUnique, setMobileUnique] = useState(false);
//     const [error, setError] = useState('');
//     const [success, setSuccess] = useState('');
//     const [showPassword, setShowPassword] = useState(false);

//     const otpInputRef = useRef(null);

//     const requiredAsteriskStyle = { '& .MuiFormLabel-asterisk': { color: 'red', }, };

//     const resetUser = () => {
//         setUserName('');
//         setMobileNumber('');
//         setEmployeeName('');
//         setUserEmailId('');
//         setUserPassword('');
//         setOtp(['', '', '', '', '', '']);
//         setOtpSent(false);
//         setOtpFocused(false);
//         setUsernameError('');
//         setUsernameValid(false);
//         setMobileError('');
//         setMobileUnique(false);
//     };

//     const checkUsername = async () => {
//         if (!userName.trim()) return;
//         try {
//             const res = await axios.post(`${path}/api/checkUsername`, { userName: userName.trim() });
//             if (!res.data.unique) {
//                 setUsernameError(`Taken. Try: ${res.data.suggestions?.join(', ') || ''}`);
//                 setUsernameValid(false);
//             } else {
//                 setUsernameError('');
//                 setUsernameValid(true);
//             }
//         } catch {
//             setUsernameError('Check failed');
//             setUsernameValid(false);
//         }
//     };

//     const checkMobile = async () => {
//         if (mobileNumber.length !== 10) return;
//         try {
//             const res = await axios.post(`${path}/api/checkMobile`, { mobileNumber });
//             setMobileUnique(res.data.unique);
//             setMobileError(res.data.unique ? '' : 'Mobile already registered');
//         } catch {
//             setMobileError('Check failed');
//             setMobileUnique(false);
//         }
//     };

//     const sendOtp = async () => {
//         try {
//             setOtpLoading(true);
//             const res = await axios.post(`${path}/api/sendOtp`, { mobileNumber, emailId: userEmailId });
//             if (res.data.success) {
//                 setOtpSent(true);
//                 setSuccess('OTP sent');
//                 setTimeout(() => otpInputRef.current?.focus(), 100);
//             }
//         } catch {
//             setError('Failed to send OTP');
//         } finally {
//             setOtpLoading(false);
//         }
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setError('');

//         if (!usernameValid || !mobileUnique || !otpSent || otp.join('').length !== 6) {
//             return setError('Complete validation and OTP');
//         }

//         try {
//             const payload = { userName, employeeName, mobileNumber, emailId: userEmailId, password: userPassword, otp: otp.join('') };
//             const { data } = await axios.post(`${path}/api/registerUser`, payload);
//             if (data.success) {
//                 setSuccess('User registered');
//                 resetUser();
//                 navigate('/ReonBook');
//             } else {
//                 setError(data.message || 'Registration failed');
//             }
//         } catch {
//             setError('Registration failed');
//         }
//     };

//     const handleOtpChange = (e) => {
//         const digits = e.target.value.replace(/\D/g, '').slice(0, 6);
//         const arr = digits.split('');
//         while (arr.length < 6) arr.push('');
//         setOtp(arr);
//     };
//     const handleOtpPaste = (e) => {
//         e.preventDefault();
//         const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
//         const arr = pasted.split('');
//         while (arr.length < 6) arr.push('');
//         setOtp(arr);
//         setTimeout(() => {
//             const el = otpInputRef.current;
//             if (el) el.setSelectionRange(pasted.length, pasted.length);
//         }, 0);
//     };

//     const handleOtpFocus = () => setOtpFocused(true);
//     const handleOtpBlur = () => setOtpFocused(false);

//     return (
//         <Box sx={{ minHeight: "100vh", display: "flex" }}>
//             <Box sx={{ display: { xs: "none", lg: "flex" }, width: "65%", position: "relative", overflow: "hidden", background: "linear-gradient(135deg, #dbeafe, #e9d5ff, #fce7f3)" }} >
//                 <Box sx={{ position: "absolute", inset: 0 }}>
//                     <Box sx={{ position: "absolute", top: 0, left: 0, width: 380, height: 380, bgcolor: "#93c5fd", borderRadius: "50%", filter: "blur(70px)", opacity: 0.4 }} />
//                     <Box sx={{ position: "absolute", bottom: 0, right: 0, width: 380, height: 380, bgcolor: "#f9a8d4", borderRadius: "50%", filter: "blur(70px)", opacity: 0.4 }} />
//                 </Box>
//                 <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", textAlign: "center", px: 6 }}>
//                     <Box sx={{ mb: 6 }}>
//                         <Box sx={{ width: 120, height: 120, mx: "auto", bgcolor: "#fff", borderRadius: 4, display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 25px 50px rgba(0,0,0,0.15)" }}>
//                             <BarChartIcon sx={{ fontSize: 60, color: "#3b82f6" }} />
//                         </Box>
//                     </Box>
//                     <Typography sx={{ fontSize: 46, fontWeight: 700, color: "#111827", mb: 2 }}>
//                         Create Your Account
//                     </Typography>
//                     <Typography sx={{ fontSize: 20, color: "#4b5563" }}>
//                         Register new users securely and<br />
//                         manage access with confidence.
//                     </Typography>
//                 </Box>
//             </Box>
//             <Box sx={{ width: { xs: "100%", lg: "35%" }, display: "flex", alignItems: "center", justifyContent: "center" }}>
//                 <Paper elevation={0} sx={{ width: "100%", maxWidth: 460, p: { xs: 3, sm: 4 }, borderRadius: 5, background: "rgba(255,255,255,0.85)", backdropFilter: "blur(14px)", border: "1px solid rgba(226,232,240,0.9)", boxShadow: ` 0 20px 40px rgba(15,23,42,0.08), inset 0 0 0 1px rgba(255,255,255,0.6) `, }} >
//                     <Box sx={{ mb: 2 }}>
//                         <Button startIcon={<ArrowBackIosNewIcon />} onClick={() => navigate("/ReonBook")} sx={{ textTransform: "none", fontWeight: 600, color: "#3b82f6", px: 0, "&:hover": { background: "transparent", color: "#1d4ed8", }, }} >
//                             Back
//                         </Button>
//                     </Box>
//                     <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
//                         <Box component="img" src="/Nexon_CRM_Final.svg" alt="Nexon CRM" sx={{ height: 38 }} />
//                     </Box>
//                     <Box sx={{ textAlign: "center", mb: 3 }}>
//                         <Typography variant="h4" fontWeight={700} sx={{ color: "#0f172a", mb: 1 }} >
//                             Create Account
//                         </Typography>
//                         <Typography sx={{ color: "#64748b", fontSize: 15 }}>
//                             Register a new user to access the CRM platform
//                         </Typography>
//                     </Box>
//                     <form onSubmit={handleSubmit}>
//                         <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
//                             <TextField label="Username" fullWidth size="small" required value={userName} onChange={e => setUserName(e.target.value)} onBlur={checkUsername} error={!!usernameError} helperText={usernameError || " "} disabled={otpFocused} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={inputStyle} />
//                             <TextField label="Mobile Number" fullWidth size="small" required value={mobileNumber} onChange={e => /^\d{0,10}$/.test(e.target.value) && setMobileNumber(e.target.value)} onBlur={checkMobile} error={!!mobileError} helperText={mobileError || "10 digits"} disabled={otpFocused} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={inputStyle} />
//                             <TextField label="Contact Person" fullWidth size="small" required value={employeeName} onChange={e => setEmployeeName(e.target.value)} disabled={otpFocused} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={inputStyle} />
//                             <TextField label="Email ID" fullWidth size="small" required value={userEmailId} onChange={e => setUserEmailId(e.target.value)} disabled={otpFocused} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={inputStyle} />
//                             <TextField label="Password" type={showPassword ? "text" : "password"} fullWidth size="small" required value={userPassword} onChange={e => setUserPassword(e.target.value)} disabled={otpFocused} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={inputStyle}
//                                 InputProps={{ endAdornment: (<InputAdornment position="end"><IconButton onClick={() => setShowPassword((prev) => !prev)} edge="end" >{showPassword ? <VisibilityOff /> : <Visibility />}</IconButton></InputAdornment>), }} />
//                             {otpSent && ( <TextField inputRef={otpInputRef} label="Enter OTP" value={otp.join("")} onChange={handleOtpChange} onPaste={handleOtpPaste} onFocus={handleOtpFocus} onBlur={handleOtpBlur} fullWidth size="small" sx={inputStyle} /> )}
//                             <Box sx={{ display: "flex", gap: 2, mt: 1 }}>
//                                 <Button variant="outlined" fullWidth disabled={ !mobileUnique || otpSent || mobileNumber.length !== 10 || otpLoading } onClick={sendOtp} sx={secondaryBtn} >
//                                     {otpLoading ? (<CircularProgress size={22} />) : ("Get OTP")}
//                                 </Button>
//                                 <Button variant="contained" type="submit" fullWidth disabled={!usernameValid || !mobileUnique || !otpSent || otp.join("").length !== 6} sx={primaryBtn} >
//                                     Register
//                                 </Button>
//                             </Box>
//                         </Box>
//                         {error && (<Typography color="error" sx={{ mt: 2, textAlign: "center" }}>{error}</Typography>)}
//                         {success && (<Typography color="success.main" sx={{ mt: 2, textAlign: "center" }}>{success}</Typography>)}
//                     </form>
//                 </Paper>
//             </Box>
//         </Box>
//     );
// }
// const inputStyle = {
//     "& .MuiOutlinedInput-root": {
//         borderRadius: 3, height: 38, backgroundColor: "#f9fafb",
//         "& fieldset": { borderColor: "#e5e7eb" },
//         "&:hover fieldset": { borderColor: "#3b82f6" },
//         "&.Mui-focused fieldset": { borderColor: "#3b82f6", borderWidth: 2 },
//     },
//     "& .MuiInputLabel-root.Mui-focused": { color: "#3b82f6" },
// };
// const primaryBtn = {
//     py: 1.4, borderRadius: 3, fontWeight: 600, textTransform: "none",
//     background: "linear-gradient(to right, #3b82f6, #2563eb)",
//     boxShadow: "0 10px 25px rgba(59,130,246,0.35)",
//     "&:hover": { background: "linear-gradient(to right, #2563eb, #1d4ed8)" },
// };
// const secondaryBtn = {
//     py: 1.4, borderRadius: 3, fontWeight: 600, textTransform: "none",
//     borderColor: "#c7d2fe", color: "#2563eb",
//     "&:hover": { bgcolor: "#eef2ff", borderColor: "#3b82f6" },
// };

import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Box, Typography, TextField, Button, CircularProgress, IconButton, InputAdornment, Divider } from '@mui/material';
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import CheckIcon from "@mui/icons-material/Check";

export default function Registration({ connectionString }) {
    const navigate = useNavigate();
    const path = connectionString;

    // ================= EXISTING LOGIC (UNCHANGED) =================
    const [userName, setUserName] = useState('');
    const [mobileNumber, setMobileNumber] = useState('');
    const [employeeName, setEmployeeName] = useState('');
    const [userEmailId, setUserEmailId] = useState('');
    const [userPassword, setUserPassword] = useState('');
    const [otp, setOtp] = useState(['', '', '', '', '', '']);
    const [otpSent, setOtpSent] = useState(false);
    const [otpFocused, setOtpFocused] = useState(false);
    const [otpLoading, setOtpLoading] = useState(false);

    const [usernameError, setUsernameError] = useState('');
    const [usernameValid, setUsernameValid] = useState(false);
    const [mobileError, setMobileError] = useState('');
    const [mobileUnique, setMobileUnique] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const otpInputRef = useRef(null);

    const requiredAsteriskStyle = { '& .MuiFormLabel-asterisk': { color: 'red' } };

    const resetUser = () => {
        setUserName(''); setMobileNumber(''); setEmployeeName('');
        setUserEmailId(''); setUserPassword('');
        setOtp(['', '', '', '', '', '']);
        setOtpSent(false); setOtpFocused(false);
        setUsernameError(''); setUsernameValid(false);
        setMobileError(''); setMobileUnique(false);
    };

    const checkUsername = async () => {
        if (!userName.trim()) return;
        try {
            const res = await axios.post(`${path}/api/checkUsername`, { userName: userName.trim() });
            if (!res.data.unique) {
                setUsernameError(`Taken. Try: ${res.data.suggestions?.join(', ') || ''}`);
                setUsernameValid(false);
            } else {
                setUsernameError('');
                setUsernameValid(true);
            }
        } catch {
            setUsernameError('Check failed');
            setUsernameValid(false);
        }
    };

    const checkMobile = async () => {
        if (mobileNumber.length !== 10) return;
        try {
            const res = await axios.post(`${path}/api/checkMobile`, { mobileNumber });
            setMobileUnique(res.data.unique);
            setMobileError(res.data.unique ? '' : 'Mobile already registered');
        } catch {
            setMobileError('Check failed');
            setMobileUnique(false);
        }
    };

    const sendOtp = async () => {
        try {
            setOtpLoading(true);
            const res = await axios.post(`${path}/api/sendOtp`, { mobileNumber, emailId: userEmailId });
            if (res.data.success) {
                setOtpSent(true);
                setSuccess('OTP sent successfully!');
                setTimeout(() => otpInputRef.current?.focus(), 100);
            }
        } catch {
            setError('Failed to send OTP');
        } finally {
            setOtpLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        if (!usernameValid || !mobileUnique || !otpSent || otp.join('').length !== 6) {
            return setError('Complete all validation steps and enter OTP');
        }
        try {
            const payload = { userName, employeeName, mobileNumber, emailId: userEmailId, password: userPassword, otp: otp.join('') };
            const { data } = await axios.post(`${path}/api/registerUser`, payload);
            if (data.success) {
                setSuccess('User registered successfully!');
                resetUser();
                navigate('/');
            } else {
                setError(data.message || 'Registration failed');
            }
        } catch {
            setError('Registration failed');
        }
    };

    const handleOtpChange = (e) => {
        const digits = e.target.value.replace(/\D/g, '').slice(0, 6);
        const arr = digits.split('');
        while (arr.length < 6) arr.push('');
        setOtp(arr);
    };

    const handleOtpPaste = (e) => {
        e.preventDefault();
        const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
        const arr = pasted.split('');
        while (arr.length < 6) arr.push('');
        setOtp(arr);
        setTimeout(() => {
            const el = otpInputRef.current;
            if (el) el.setSelectionRange(pasted.length, pasted.length);
        }, 0);
    };

    const handleOtpFocus = () => setOtpFocused(true);
    const handleOtpBlur = () => setOtpFocused(false);

    const benefits = [
        "Instant access after OTP verification",
        "Multi-company support from day one",
        "GST-ready invoicing & filings",
        "Secure role-based access control",
    ];

    const stats = [
        { label: "Businesses", value: "10K+", icon: "🏢" },
        { label: "Revenue Tracked", value: "₹500Cr+", icon: "📊" },
        { label: "Uptime", value: "99.9%", icon: "⚡" },
    ];

    // ================= UI =================

    return (
        <Box sx={{ height: "100vh", overflow: "hidden", display: "flex" }}>

            {/* ── LEFT PANEL ── */}
            <Box sx={{
                display: { xs: "none", lg: "flex" },
                width: "58%",
                flexDirection: "column",
                justifyContent: "space-between",
                position: "relative",
                overflow: "hidden",
                background: "linear-gradient(150deg, #071330 0%, #0c2461 45%, #1565c0 100%)",
                p: { lg: "48px 52px", xl: "64px 72px" },
            }}>
                {/* Dot grid */}
                <Box sx={{ position: "absolute", inset: 0, pointerEvents: "none", opacity: 0.06, backgroundImage: "radial-gradient(circle, #fff 1px, transparent 1px)", backgroundSize: "28px 28px" }} />
                {/* Glow top-right */}
                <Box sx={{ position: "absolute", top: "-20%", right: "-10%", width: 520, height: 520, borderRadius: "50%", background: "radial-gradient(circle, rgba(24,119,242,0.35) 0%, transparent 68%)", pointerEvents: "none" }} />
                {/* Glow bottom-left */}
                <Box sx={{ position: "absolute", bottom: "-15%", left: "-15%", width: 460, height: 460, borderRadius: "50%", background: "radial-gradient(circle, rgba(8,85,168,0.4) 0%, transparent 68%)", pointerEvents: "none" }} />

                {/* Logo */}
                <Box sx={{ position: "relative", zIndex: 1 }}>
                    <Box component="img" src="/RBLOGOBLUE.svg" alt="ReonBook" sx={{ height: 32, filter: "brightness(0) invert(1)", opacity: 0.92 }} />
                </Box>

                {/* Hero text */}
                <Box sx={{ position: "relative", zIndex: 1 }}>
                    <Typography sx={{ color: "#60a5fa", fontSize: "0.72rem", fontWeight: 700, letterSpacing: "3px", textTransform: "uppercase", mb: 2.5 }}>
                        Enterprise Accounting Platform
                    </Typography>
                    <Typography sx={{ fontSize: { lg: "2.4rem", xl: "3rem" }, fontWeight: 800, color: "#f0f6ff", lineHeight: 1.15, mb: 2.5 }}>
                        Create Your<br />
                        <Box component="span" sx={{ background: "linear-gradient(90deg, #60a5fa 0%, #a5c8ff 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>
                            ReonBook Account
                        </Box>
                    </Typography>
                    <Typography sx={{ color: "rgba(255,255,255,0.55)", fontSize: "0.92rem", lineHeight: 1.85, maxWidth: 420, mb: 4.5 }}>
                        Register securely and get instant access to the complete accounting suite — invoices, ledgers, GST reports, and more.
                    </Typography>

                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.6 }}>
                        {benefits.map((feat) => (
                            <Box key={feat} sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                                <Box sx={{ width: 22, height: 22, borderRadius: "50%", bgcolor: "rgba(96,165,250,0.15)", border: "1.5px solid rgba(96,165,250,0.55)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                    <CheckIcon sx={{ fontSize: 12, color: "#60a5fa" }} />
                                </Box>
                                <Typography sx={{ color: "rgba(255,255,255,0.78)", fontSize: "0.87rem" }}>{feat}</Typography>
                            </Box>
                        ))}
                    </Box>
                </Box>

                {/* Stat cards */}
                <Box sx={{ display: "flex", gap: 1.5, position: "relative", zIndex: 1 }}>
                    {stats.map((stat) => (
                        <Box key={stat.label} sx={{
                            flex: 1,
                            bgcolor: "rgba(255,255,255,0.06)",
                            border: "1px solid rgba(255,255,255,0.1)",
                            borderRadius: 2.5,
                            p: { lg: 2, xl: 2.5 },
                        }}>
                            <Typography sx={{ fontSize: "1.35rem", mb: 0.8 }}>{stat.icon}</Typography>
                            <Typography sx={{ color: "#fff", fontWeight: 800, fontSize: "1.05rem", mb: 0.2 }}>{stat.value}</Typography>
                            <Typography sx={{ color: "rgba(255,255,255,0.45)", fontSize: "0.68rem", textTransform: "uppercase", letterSpacing: "1px" }}>{stat.label}</Typography>
                        </Box>
                    ))}
                </Box>
            </Box>

            {/* ── RIGHT PANEL ── */}
            <Box sx={{
                width: { xs: "100%", lg: "42%" },
                height: "100vh",
                overflowY: "auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                p: { xs: 3, sm: 4, md: 5 },
                bgcolor: "#ffffff",
                position: "relative",
            }}>
                <Box sx={{ position: "absolute", inset: 0, pointerEvents: "none", background: "radial-gradient(ellipse at 80% 10%, rgba(24,119,242,0.04) 0%, transparent 50%), radial-gradient(ellipse at 20% 90%, rgba(10,102,194,0.04) 0%, transparent 50%)" }} />

                <Box sx={{ width: "100%", maxWidth: 400, position: "relative", zIndex: 1 }}>

                    {/* Back button */}
                    <Button startIcon={<ArrowBackIosNewIcon sx={{ fontSize: "0.9rem !important" }} />}
                        onClick={() => navigate("/")}
                        sx={{ textTransform: "none", fontWeight: 600, color: "#1877F2", px: 0, mb: 2, minWidth: 0, "&:hover": { background: "transparent", color: "#0A66C2" } }}>
                        Back to Login
                    </Button>

                    {/* Logo — only on mobile/tablet where left panel is hidden */}
                    <Box sx={{ display: { xs: "flex", lg: "none" }, justifyContent: "center", mb: 3 }}>
                        <Box component="img" src="/RBLOGOBLUE.svg" alt="ReonBook" sx={{ height: 38 }} />
                    </Box>

                    {/* Heading */}
                    <Box sx={{ mb: 3 }}>
                        <Typography variant="h4" fontWeight={800} sx={{ color: "#0f172a", fontSize: { xs: "1.5rem", sm: "1.75rem" }, mb: 0.8, letterSpacing: "-0.5px" }}>
                            Create Account
                        </Typography>
                        <Typography sx={{ color: "#64748b", fontSize: "0.88rem" }}>
                            Register a new user to access the accounting platform
                        </Typography>
                    </Box>

                    {/* Form */}
                    <form onSubmit={handleSubmit}>
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>

                            <TextField label="Username" fullWidth size="small" required
                                value={userName} onChange={e => setUserName(e.target.value)} onBlur={checkUsername}
                                error={!!usernameError} helperText={usernameError || " "}
                                disabled={otpFocused} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={fieldSx} />

                            <TextField label="Mobile Number" fullWidth size="small" required
                                value={mobileNumber}
                                onChange={e => /^\d{0,10}$/.test(e.target.value) && setMobileNumber(e.target.value)}
                                onBlur={checkMobile} error={!!mobileError} helperText={mobileError || "10 digits"}
                                disabled={otpFocused} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={fieldSx} />

                            <TextField label="Contact Person" fullWidth size="small" required
                                value={employeeName} onChange={e => setEmployeeName(e.target.value)}
                                disabled={otpFocused} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={fieldSx} />

                            <TextField label="Email ID" fullWidth size="small" required
                                value={userEmailId} onChange={e => setUserEmailId(e.target.value)}
                                disabled={otpFocused} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={fieldSx} />

                            <TextField label="Password" type={showPassword ? "text" : "password"} fullWidth size="small" required
                                value={userPassword} onChange={e => setUserPassword(e.target.value)}
                                disabled={otpFocused} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={fieldSx}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={() => setShowPassword(p => !p)} edge="end" size="small">
                                                {showPassword ? <VisibilityOff sx={{ fontSize: 18 }} /> : <Visibility sx={{ fontSize: 18 }} />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }} />

                            {otpSent && (
                                <TextField inputRef={otpInputRef} label="Enter OTP" value={otp.join("")}
                                    onChange={handleOtpChange} onPaste={handleOtpPaste}
                                    onFocus={handleOtpFocus} onBlur={handleOtpBlur}
                                    fullWidth size="small" sx={{ ...fieldSx, mt: 0.5 }} />
                            )}

                            <Divider sx={{ my: 1, borderColor: "#f1f5f9" }} />

                            {/* Action buttons */}
                            <Box sx={{ display: "flex", gap: 1.5 }}>
                                <Button variant="outlined" fullWidth
                                    disabled={!mobileUnique || otpSent || mobileNumber.length !== 10 || otpLoading}
                                    onClick={sendOtp} sx={secondaryBtn}>
                                    {otpLoading ? <CircularProgress size={18} /> : "Get OTP"}
                                </Button>
                                <Button variant="contained" type="submit" fullWidth
                                    disabled={!usernameValid || !mobileUnique || !otpSent || otp.join("").length !== 6}
                                    sx={primaryBtn}>
                                    Register
                                </Button>
                            </Box>
                        </Box>

                        {error && (
                            <Box sx={{ bgcolor: "#fef2f2", border: "1px solid #fecaca", color: "#dc2626", p: "10px 14px", borderRadius: 2, mt: 2, fontSize: "0.82rem" }}>
                                {error}
                            </Box>
                        )}
                        {success && (
                            <Box sx={{ bgcolor: "#ecfdf5", border: "1px solid #a7f3d0", color: "#047857", p: "10px 14px", borderRadius: 2, mt: 2, fontSize: "0.82rem" }}>
                                {success}
                            </Box>
                        )}
                    </form>

                    <Typography align="center" sx={{ mt: 3.5, color: "#94a3b8", fontSize: "0.73rem" }}>
                        © {new Date().getFullYear()} Powered by{" "}
                        <a href="http://soltrack.co.in/" target="_blank" rel="noreferrer" style={{ color: "#475569", fontWeight: 600, textDecoration: "none" }}>
                            Soltrack Technologies Pvt Ltd
                        </a>
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
}

const fieldSx = {
    "& .MuiOutlinedInput-root": {
        borderRadius: 2,
        backgroundColor: "#f8faff",
        "& fieldset": { borderColor: "#e2e8f0" },
        "&:hover fieldset": { borderColor: "#1877F2" },
        "&.Mui-focused fieldset": { borderColor: "#1877F2", borderWidth: 2 },
    },
    "& .MuiInputLabel-root.Mui-focused": { color: "#1877F2" },
};

const primaryBtn = {
    py: 1.3,
    borderRadius: 2,
    fontWeight: 700,
    textTransform: "none",
    background: "linear-gradient(135deg, #1877F2 0%, #0A66C2 100%)",
    boxShadow: "0 4px 14px rgba(24,119,242,0.28)",
    "&:hover": { background: "linear-gradient(135deg, #0A66C2 0%, #0855A8 100%)", boxShadow: "0 6px 18px rgba(24,119,242,0.4)" },
};

const secondaryBtn = {
    py: 1.3,
    borderRadius: 2,
    fontWeight: 600,
    textTransform: "none",
    borderColor: "#dbeafe",
    color: "#1877F2",
    "&:hover": { bgcolor: "#eff6ff", borderColor: "#1877F2" },
};
